import { z } from 'zod';
import { VALIDATION_MESSAGES } from 'pages/Main/QRScreens/constants';

export const infoCollectionSchema = z.object({
  firstName: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
  lastName: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
  email: z
    .string()
    .min(1, { message: VALIDATION_MESSAGES.required })
    .email({ message: VALIDATION_MESSAGES.invalidEmail }),
  company: z.string().optional(),
});
